// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"w8-z"};